import { createContext } from "react";

const CursosPublicosContext = createContext();

export default CursosPublicosContext;
